(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Drifting embers
  var field = document.querySelector('.embers');
  if (field && !reduce) {
    var count = window.innerWidth < 720 ? 14 : 26;
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.style.left = Math.random() * 100 + '%';
      s.style.animationDuration = 9 + Math.random() * 12 + 's';
      s.style.animationDelay = Math.random() * 14 + 's';
      s.style.setProperty('--drift', (Math.random() * 120 - 60).toFixed(0) + 'px');
      var size = (1.5 + Math.random() * 2.5).toFixed(1) + 'px';
      s.style.width = size; s.style.height = size;
      field.appendChild(s);
    }
  }

  // Countdown to launch
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var parts = {
      d: el.querySelector('[data-unit="d"]'),
      h: el.querySelector('[data-unit="h"]'),
      m: el.querySelector('[data-unit="m"]'),
      s: el.querySelector('[data-unit="s"]')
    };
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.classList.add('countdown--done'); return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var sec = Math.floor(diff / 1000) % 60;
      if (parts.d) parts.d.textContent = d;
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(sec);
      setTimeout(tick, 1000);
    }
    tick();
  });

  // Reveal on scroll
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var max = parseInt(input.getAttribute('max'), 10) || 99;
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.getAttribute('data-step') === 'up' ? Math.min(max, v + 1) : Math.max(1, v - 1);
        input.value = v;
      });
    });
  });

  // Product thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        main.srcset = '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Inscription toggle: show the name field only when the buyer wants one
  document.querySelectorAll('[data-inscribe-toggle]').forEach(function (cb) {
    var target = document.getElementById(cb.getAttribute('aria-controls'));
    if (!target) return;
    var input = target.querySelector('input');
    function sync() {
      target.hidden = !cb.checked;
      if (input) { input.disabled = !cb.checked; }
    }
    cb.addEventListener('change', sync);
    sync();
  });
})();
